import { render, staticRenderFns } from "./TaskIcon.vue?vue&type=template&id=52546b2e"
import script from "./TaskIcon.vue?vue&type=script&lang=js"
export * from "./TaskIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports